import {Injectable} from '@angular/core';

import {materials, fabrics} from '../../data/fabrics/fabrics.manifest.json';
import FabricInterface from '../models/fabric.interface';
import MaterialInterface from '../models/material.interface';

@Injectable({
    providedIn: 'root'
})
export class FabricRepository {

    private allFabrics: FabricInterface[] = null;

    constructor() {
    }

    public all(): FabricInterface[] {
        if (!this.allFabrics) {
            this.allFabrics = fabrics.map(fabric => {
                return {
                    id: fabric.id,
                    name: fabric.name,
                    position: fabric.position,
                    path: `/assets/configurator/fabrics/${fabric.filename}`,
                    previewPath: `/assets/configurator/fabrics/${fabric.previewFilename}`,
                    headerPath: fabric.headerFilename ? `/assets/configurator/fabrics/${fabric.headerFilename}` : false,
                    width: fabric.width,
                    height: fabric.height,
                    material: fabric.material,
                    variation: fabric.variation || null,
                    details: fabric.details,
                    shop: fabric.shop,
                    // @ts-ignore
                    slides: fabric.slides ? fabric.slides.map(slide => `/assets/configurator/fabrics/sliders/${slide}`) : []
                };
            });
        }

        return this.allFabrics;
    }

    getByIdOrFirst(id): FabricInterface {
        return this.all().find(fabric => fabric.id === id) ?? this.all()[0];
    }

    public materials(): MaterialInterface[] {
        return materials.map(material => {
            const fabricsInMaterial: FabricInterface[] = this.all().filter(fabric => fabric.material === material.id);
            return {
                id: material.id,
                name: material.name,
                position: material.position,
                fabrics: fabricsInMaterial,
                description: material.description,
                variations: material.variations?.map(variation => {
                    return {
                        id: variation,
                        name: variation.charAt(0).toUpperCase() + variation.substring(1)
                    };
                }) ?? undefined
            };
        });
    }

    public materialById(id): MaterialInterface {
        return this.materials().find(material => material.id === id);
    }
}
